import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"right\">\n  <path fill=\"#37322F\" fill-rule=\"evenodd\" d=\"M69.69 43.195 37.495 11l-2.3 2.3 32.196 32.195L35.195 77.69l2.3 2.3L69.69 47.795l2.3-2.3-2.3-2.3Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol